<template>
    <div style="overflow-x: hidden;">
        <div class="col-12 mx-auto">
            <p class="mb-0 fts-18 pl-3 h-emphasis" style="font-weight: 900;">Détail du portefeuille</p>
        </div>
        <div class="col-12 mx-auto py-3">
            <div class="row justify-content-center">
                <div class="col-md-5 my-4">
                    <p class="fts-20 m-emphasis text-center">Sélectionnez une enveloppe pour obtenir une comparaison immédiate</p>
                    <p class="fts-20 m-emphasis text-center">Mes enveloppes</p>
                    <div v-for="(comparison, index) in customs" :key="index" class="mx-auto my-3" style="width: 250px;">
                        <p class="fts-20 m-emphasis text-center">{{comparison.contract.name}} {{comparison.platform.name}} {{comparison.sum_assets}}</p>
                        <button class="btn-alt-2" v-b-modal="modalId(comparison.platform_contract.id)">
                            Décomposition
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-plus-circle ml-1" style= "margin-bottom: 2px;" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                            </svg>
                        </button>
                    </div>
                    <b-modal
                        :title="'La décomposition de votre allocation'+comparison.name"
                        class="modal fade alt-list" :id="'modal' + comparison.platform_contract.id"
                        tabindex="-1"
                        role="dialog"
                        size="xl"
                        aria-labelledby="alternatives"
                        aria-hidden="true"
                        :header-bg-variant="headerBgVariant"
                        :header-text-variant="headerTextVariant"
                        :body-bg-variant="bodyBgVariant"
                        :body-text-variant="bodyTextVariant"
                        :footer-bg-variant="footerBgVariant"
                        :footer-text-variant="footerTextVariant"
                        ok-only
                        >
                        <div style="display: contents;">
                            <table class="myfotable-dark">
                                <colgroup>
                                    <col style="width: 30%;">
                                    <col style="width: 10%;">
                                    <col style="width: 20%;">
                                    <col style="width: 10%;">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th style="text-align: left;">Titre</th>
                                        <th>ISIN</th>
                                        <th>Répartition</th>
                                        <th>Décomposition</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(alternative, i) in comparison.positions" :key="i">
                                        <td style="font-weight: bold; color: rgb(187, 134, 252); text-align: left;">{{ alternative.name }}</td>
                                        <td>{{ alternative.security.isin }}</td>
                                        <td>{{ alternative.weight }}</td>
                                        <td v-if="alternative.security_lookthrough > 0">
                                            <button class="btn-alt-2" v-b-modal="modalId(alternative.isin+' '+comparison.platform_contract.id)">
                                                Décomposition
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-plus-circle ml-1" style= "margin-bottom: 2px;" viewBox="0 0 16 16">
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                                </svg>
                                            </button>
                                        </td>
                                        <td v-else>
                                        </td>
                                        <b-modal
                                            :title="'La décomposition de votre allocation'"
                                            class="modal fade alt-list" :id="'modal' + alternative.isin+' '+comparison.platform_contract.id"
                                            tabindex="-1"
                                            role="dialog"
                                            size="xl"
                                            aria-labelledby="alternatives"
                                            aria-hidden="true"
                                            :header-bg-variant="headerBgVariant"
                                            :header-text-variant="headerTextVariant"
                                            :body-bg-variant="bodyBgVariant"
                                            :body-text-variant="bodyTextVariant"
                                            :footer-bg-variant="footerBgVariant"
                                            :footer-text-variant="footerTextVariant"
                                            ok-only
                                            >
                                            <div style="display: contents;">
                                                <table class="myfotable-dark">
                                                    <colgroup>
                                                        <col style="width: 30%;">
                                                        <col style="width: 10%;">
                                                        <col style="width: 20%;">
                                                    </colgroup>
                                                    <thead>
                                                        <tr>
                                                            <th style="text-align: left;">Position</th>
                                                            <th>ISIN</th>
                                                            <th>Poids (%)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(lookthrough, i) in alternative.security_lookthrough" :key="i">
                                                            <td style="font-weight: bold; color: rgb(187, 134, 252); text-align: left;">{{ lookthrough.name }}</td>
                                                            <td>{{ lookthroughsecurity.security.isin }}</td>
                                                            <td>{{ lookthrough.weight }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </b-modal>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="access === false" class="text-center mt-4">
                                <p class="light-white-02">Passez à la version premium pour accéder aux détails de vos positions</p>
                                <button class="btn-transparncy m-3"><a :href="'/app/home/payment/portal'">Upgrader</a></button>
                            </div>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'platform_contract_portfolio',
            'access_granted',
            'token',
            'route',
        ],

        data() {
            return {
                customs:[],
                comparison: this.platform_contract_portfolio[1],
                access:"",
                show: false,
                variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
                headerBgVariant: 'info',
                headerTextVariant: 'light',
                bodyBgVariant: 'dark',
                bodyTextVariant: 'dark',
                footerBgVariant: 'info',
                footerTextVariant: 'dark'
            }
        },

        mounted() {
            this.platform_contract_portfolio.forEach(comparison =>
            {
                this.customs.push(comparison)
            });
            this.access = this.accessgranted;
        },


        methods: {
            modalId(i) {
            return 'modal' + i;
            },
    }
}

</script>